export default __webpack_public_path__ + "static/media/anchor.2b5e03d8.png";